import React from 'react';
import './LoadingOverlay.css';

const LoadingOverlay = ({ message = 'Loading...', onClose }) => {
  return (
    <div className="loading-overlay">
      <div className="loading-content">
        <button 
          className="close-button" 
          onClick={onClose}
          aria-label="Close loading overlay"
          tabIndex="0"
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              onClose();
            }
          }}
        >
          ×
        </button>
        <div className="loading-spinner">
          <svg className="spinner" viewBox="0 0 50 50">
            <circle className="path" cx="25" cy="25" r="20" fill="none" strokeWidth="5"></circle>
          </svg>
        </div>
        <div className="loading-message">{message}</div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
